// extracted by mini-css-extract-plugin
export default {"container":"ViewMerchantsCallback_container__kAmH0","content":"ViewMerchantsCallback_content__eglSv","title":"ViewMerchantsCallback_title__i22E6"};